export class OTTCardSettings {
  constructor() {
    let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    Object.assign(this, new HomeCardsSettings(overrides), new VendorCardsSettings(overrides), new CategoryCardsSettings(overrides), new DetailsCardSettings(overrides));
  }
}
class HomeCardsSettings {
  constructor() {
    let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const defaults = {
      homeHeight: {
        type: 'px',
        value: 225
      },
      homeWidth: {
        type: '%',
        value: 100
      },
      homePadding: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      },
      homeMargin: {
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
        marginBottom: 0
      },
      homeFont: {
        fontSize: 14,
        fontWeight: '400',
        color: '#000000',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      homeBackground: '#e3e3e3',
      homeBorder: {
        borderWidth: 2,
        borderColor: '#7e7b7b',
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
        borderStyle: 'solid'
      },
      homeCardsHeight: {
        type: 'px',
        value: 156
      },
      homeCardsWidth: {
        type: 'px',
        value: 156
      },
      homeCardsMargin: {
        marginLeft: 10,
        marginRight: 10,
        marginTop: 10,
        marginBottom: 10
      },
      homeCardsFont: {
        fontSize: 14,
        fontWeight: '400',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      homeCardsPadding: {
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 10,
        paddingBottom: 10
      },
      homeCardsBackground: '#e3e3e3',
      homeCardsBorder: {
        borderWidth: 2,
        borderColor: '#7e7b7b',
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
        borderStyle: 'solid'
      },
      homeCardsImgsWidth: {
        type: 'px',
        value: 50
      },
      homeCardsImgsMargin: {
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
        marginBottom: 0
      },
      homeCardsImgsPadding: {
        PaddingLeft: 0,
        PaddingRight: 0,
        PaddingTop: 0,
        PaddingBottom: 0
      },
      homeChevronColor: '#000000',
      homeBubbleColor: '#ffffff',
      homeBubbleFont: {
        fontSize: 14,
        fontWeight: '400',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      arrowColor: '#000000'
    };
    Object.assign(this, defaults, overrides);
  }
}
class VendorCardsSettings {
  constructor() {
    let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const defaults = {
      vendorHeight: {
        type: 'px',
        value: 240
      },
      vendorWidth: {
        type: '%',
        value: 100
      },
      vendorPadding: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      },
      vendorMargin: {
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
        marginBottom: 0
      },
      vendorBackground: '#e3e3e3',
      vendorBorder: {
        borderWidth: 2,
        borderColor: '#7e7b7b',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderStyle: 'solid'
      },
      vendorCardsHeight: {
        type: 'px',
        value: 150
      },
      vendorCardsWidth: {
        type: 'px',
        value: 150
      },
      vendorCardsMargin: {
        marginLeft: 10,
        marginRight: 10,
        marginTop: 10,
        marginBottom: 10
      },
      vendorCardsBackground: '#ffffff',
      vendorCardsPadding: {
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 10,
        paddingBottom: 10
      },
      vendorCardsFont: {
        fontSize: 14,
        fontWeight: '400',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      vendorCardsBorder: {
        borderWidth: 2,
        borderColor: '#7e7b7b',
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
        borderStyle: 'solid'
      },
      alphabetizeVendors: false,
      vendorConsentToggleConsentText: 'Consent',
      vendorConsentToggleLegitText: 'Legitimate Interest',
      vendorConsentToggleWidth: {
        type: 'px',
        value: 700
      },
      vendorConsentToggleHeight: {
        type: 'px',
        value: 36
      },
      vendorConsentTogglePadding: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      },
      vendorConsentToggleMargin: {
        marginLeft: 0,
        marginRight: 0,
        marginTop: 10,
        marginBottom: 5
      },
      vendorConsentToggleBackground: '#c9c9c9',
      vendorConsentToggleOnBackground: 'white',
      vendorConsentToggleConsentFont: {
        fontSize: 14,
        fontWeight: '400',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      vendorConsentToggleLegitFont: {
        fontSize: 14,
        fontWeight: '400',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      vendorConsentToggleLanguages: {},
      vendorConsentToggleSelectedLanguage: '',
      vendorSwitchOnColor: '#47d747',
      vendorSwitchOffColor: '#cccccc',
      vendorCountFont: {
        fontSize: 12,
        fontWeight: '400',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      vendorCountText: 'vendors',
      noVendorsFoundFont: {
        fontSize: 21,
        fontWeight: '400',
        color: '#0000006b',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      noVendorsFoundText: 'No Vendors Found!',
      vendorSearchBackgroundColor: '#80808069',
      vendorSearchPlaceholderText: 'Search Site Vendors...',
      vendorSearchFontStyles: {
        fontSize: 14,
        fontWeight: '400',
        color: '#0000006b',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      vendorSearchMagnifyingGlassColor: '#000000',
      vendorChevronColor: '#000000'
    };
    Object.assign(this, defaults, overrides);
  }
}
class CategoryCardsSettings {
  constructor() {
    let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const defaults = {
      categoryHeight: {
        type: 'px',
        value: 240
      },
      categoryWidth: {
        type: '%',
        value: 100
      },
      categoryPadding: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      },
      categoryMargin: {
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
        marginBottom: 0
      },
      categoryBackground: '#e3e3e3',
      categoryBorder: {
        borderWidth: 2,
        borderColor: '#7e7b7b',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderStyle: 'solid'
      },
      categoryConsentToggleWidth: {
        type: 'px',
        value: 700
      },
      categoryConsentTogglePadding: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      },
      categoryConsentToggleBackground: '#c9c9c9',
      categoryConsentToggleOnBackground: 'white',
      categoryConsentToggleFont: {
        fontSize: 14,
        fontWeight: '400',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      categoryPurposeCountText: 'purposes',
      categorySpecialPurposeCountText: 'special purposes',
      categoryFeatureCountText: 'features',
      categorySpecialFeatureCountText: 'special features',
      categoryCardsBackground: 'white',
      categoryCardsHeight: {
        type: 'px',
        value: 150
      },
      categoryCardsWidth: {
        type: 'px',
        value: 150
      },
      categoryCardsMargin: {
        marginLeft: 10,
        marginRight: 10,
        marginTop: 10,
        marginBottom: 10
      },
      categoryCardsPadding: {
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 10,
        paddingBottom: 10
      },
      categoryCardsFont: {
        fontSize: 16,
        fontWeight: '400',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      categoryCardsBorder: {
        borderWidth: 2,
        borderColor: '#7e7b7b',
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
        borderStyle: 'solid'
      },
      categoryConsentToggleConsentText: 'Consent',
      categoryConsentToggleLegitText: 'Legitimate Interest',
      categoryConsentToggleWidth: {
        type: 'px',
        value: 700
      },
      categoryConsentToggleHeight: {
        type: 'px',
        value: 36
      },
      categoryConsentTogglePadding: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      },
      categoryConsentToggleMargin: {
        marginLeft: 0,
        marginRight: 0,
        marginTop: 10,
        marginBottom: 0
      },
      categoryConsentToggleBackground: '#c9c9c9',
      categoryConsentToggleOnBackground: 'white',
      categoryConsentToggleConsentFont: {
        fontSize: 14,
        fontWeight: '400',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      categoryConsentToggleLegitFont: {
        fontSize: 14,
        fontWeight: '400',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      categoryCountFont: {
        fontSize: 12,
        fontWeight: '400',
        color: '0000009e',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      categoryConsentToggleLanguages: {},
      categoryConsentToggleSelectedLanguage: '',
      categoryChevronColor: '#000000',
      categorySwitchOnColor: '#47d747',
      categorySwitchOffColor: '#cccccc'
    };
    Object.assign(this, defaults, overrides);
  }
}
;
class DetailsCardSettings {
  constructor() {
    let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const defaults = {
      vendorDetailsBackground: '#e3e3e3',
      vendorDetailsHeight: {
        type: '%',
        value: 100
      },
      vendorDetailsWidth: {
        type: '%',
        value: 100
      },
      vendorDetailsPadding: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      },
      vendorDetailsMargin: {
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
        marginBottom: 0
      },
      vendorDetailsBorder: {
        borderWidth: 2,
        borderColor: '#7e7b7b',
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
        borderStyle: 'solid'
      },
      vendorDetailsReturnFont: {
        fontSize: 16,
        fontWeight: '600',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      vendorDetailsTitleFont: {
        fontSize: 16,
        fontWeight: '500',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      vendorDetailsCardBackground: 'white',
      vendorDetailsCardHeight: {
        type: '%',
        value: 100
      },
      vendorDetailsCardWidth: {
        type: '%',
        value: 90
      },
      vendorDetailsCardPadding: {
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 10,
        paddingBottom: 10
      },
      vendorDetailsCardMargin: {
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
        marginBottom: 0
      },
      vendorDetailsPurposesText: 'Purposes',
      vendorDetailsLegitText: 'Legitimate Interest',
      vendorDetailsFeatureText: 'Features',
      vendorDetailsSpecialPurposeText: 'Special Purpose',
      vendorDetailsCardHeaderFont: {
        fontSize: 12,
        fontWeight: '300',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      vendorDetailsCardFont: {
        fontSize: 14,
        fontWeight: '400',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      vendorDetailsCardBorder: {
        borderWidth: 1,
        borderColor: '#7e7b7b',
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
        borderStyle: 'solid'
      },
      vendorDetailsReturnText: 'RETURN',
      vendorDetailsReturnArrowColor: '#000000',
      vendorDetailsCategoryCountFont: {
        fontSize: 16,
        fontWeight: '500',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      vendorDetailsSwitchOnColor: '#47d747',
      vendorDetailsSwitchOffColor: '#cccccc',
      vendorDetailsLanguages: {},
      vendorDetailsSelectedLanguage: '',
      categoryDetailsBackground: 'white',
      categoryDetailsHeight: {
        type: '%',
        value: 100
      },
      categoryDetailsWidth: {
        type: '%',
        value: 100
      },
      categoryDetailsPadding: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      },
      categoryDetailsMargin: {
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
        marginBottom: 0
      },
      categoryDetailsBorder: {
        borderWidth: 2,
        borderColor: '#7e7b7b',
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
        borderStyle: 'solid'
      },
      categoryDetailsReturnArrowColor: '#000000',
      categoryDetailsReturnText: 'RETURN',
      categoryDetailsReturnFont: {
        fontSize: 16,
        fontWeight: '600',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      categoryDetailsTitleFont: {
        fontSize: 16,
        fontWeight: '600',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      categoryDetailsDescriptionFont: {
        fontSize: 14,
        fontWeight: '500',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      categoryDetailsVendorCountText: 'Vendors',
      categoryDetailsVendorCountFont: {
        fontSize: 14,
        fontWeight: '600',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      categoryDetailsSwitchOnColor: '#47d747',
      categoryDetailsSwitchOffColor: '#cccccc',
      categoryDetailsVendorContainerColor: '#ffffff2e',
      categoryDetailsVendorQr: true,
      categoryDetailsVendorUrl: false,
      categoryDetailsVendorFont: {
        fontSize: 14,
        fontWeight: '600',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      categoryDetailsVendorUrlFont: {
        fontSize: 11,
        fontWeight: '300',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      categoryDetailsLanguages: {},
      categoryDetailsSelectedLanguage: '',
      detailsPreviewType: 'category',
      detailsPreviewIndex: 0,
      languages: {},
      selectedLanguage: 'EN'
    };
    Object.assign(this, defaults, overrides);
  }
}
export const OTTCardsTypes = {
  'home container orientation': {
    homeWidth: {
      title: 'Width',
      type: 'Size'
    },
    homeHeight: {
      title: 'Height',
      type: 'Size'
    },
    homePadding: {
      title: 'Padding',
      type: 'Padding'
    },
    homeMargin: {
      title: 'Margin',
      type: 'Margin'
    }
  },
  'home container style': {
    homeBackground: {
      title: 'Background Color',
      type: 'ColorPicker'
    },
    homeBorder: {
      title: 'Border',
      type: 'Border'
    }
  },
  'home cards orientation': {
    homeCardsHeight: {
      title: 'Height',
      type: 'Size'
    },
    homeCardsWidth: {
      title: 'Width',
      type: 'Size'
    },
    homeCardsPadding: {
      title: 'Padding',
      type: 'Padding'
    },
    homeCardsMargin: {
      title: 'Margin',
      type: 'Margin'
    }
  },
  'home cards style': {
    homeCardsBackground: {
      title: 'Background Color',
      type: 'ColorPicker'
    },
    homeCardsFont: {
      title: 'Font',
      type: 'Font'
    },
    homeCardsBorder: {
      title: 'Border',
      type: 'Border'
    },
    homeArrowColor: {
      title: 'Arrow Color',
      type: 'ColorPicker'
    }
  },
  'home chevron style': {
    homeChevronColor: {
      title: 'Chevron Color',
      type: 'ColorPicker'
    }
  },
  'home cards image orientation': {
    homeCardsImgsWidth: {
      title: 'Width',
      type: 'Size'
    },
    homeCardsImgsPadding: {
      title: 'Padding',
      type: 'Padding'
    },
    homeCardsImgsMargin: {
      title: 'Margin',
      type: 'Margin'
    }
  },
  'home cards friendly description bubble': {
    homeBubbleColor: {
      title: 'Color',
      type: 'ColorPicker'
    },
    homeBubbleFont: {
      title: 'Font Style',
      type: 'Font'
    }
  },
  'vendors container orientation': {
    vendorWidth: {
      title: 'Width',
      type: 'Size'
    },
    vendorPadding: {
      title: 'Padding',
      type: 'Padding'
    },
    vendorMargin: {
      title: 'Margin',
      type: 'Margin'
    }
  },
  'vendors container style': {
    vendorBackground: {
      title: 'Background Color',
      type: 'ColorPicker'
    },
    vendorBorder: {
      title: 'Border',
      type: 'Border'
    }
  },
  'vendors cards orientation': {
    vendorCardsHeight: {
      title: 'Height',
      type: 'Size'
    },
    vendorCardsWidth: {
      title: 'Width',
      type: 'Size'
    },
    vendorCardsPadding: {
      title: 'Padding',
      type: 'Padding'
    },
    vendorCardsMargin: {
      title: 'Margin',
      type: 'Margin'
    }
  },
  'vendors cards style': {
    vendorCardsBackground: {
      title: 'Background Color',
      type: 'ColorPicker'
    },
    vendorCardsBorder: {
      title: 'Border',
      type: 'Border'
    },
    vendorCardsFont: {
      title: 'Font',
      type: 'Font'
    },
    vendorArrowColor: {
      title: 'Arrow Color',
      type: 'ColorPicker'
    }
  },
  'vendors chevron style': {
    vendorChevronColor: {
      title: 'Chevron Color',
      type: 'ColorPicker'
    }
  },
  'vendors content': {
    alphabetizeVendors: {
      title: 'Sort Vendors Alphabetically?',
      type: 'Switch'
    }
  },
  'vendors consent slider text': {
    vendorConsentToggleConsentText: {
      title: 'Consent Text',
      type: 'InputLanguage'
    },
    vendorConsentToggleLegitText: {
      title: 'Legitimate Interest Text',
      type: 'InputLanguage'
    }
  },
  'vendors consent slider orientation': {
    vendorConsentToggleWidth: {
      title: 'Width',
      type: 'Size'
    },
    vendorConsentToggleHeight: {
      title: 'Height',
      type: 'Size'
    },
    vendorConsentTogglePadding: {
      title: 'Padding',
      type: 'Padding'
    },
    vendorConsentToggleMargin: {
      title: 'Margin',
      type: 'Margin'
    }
  },
  'vendors consent slider style': {
    vendorConsentToggleBackground: {
      title: 'Off Switch Color',
      type: 'ColorPicker'
    },
    vendorConsentToggleOnBackground: {
      title: 'On Switch Color',
      type: 'ColorPicker'
    },
    vendorConsentToggleConsentFont: {
      title: 'Consent Font',
      type: 'Font'
    },
    vendorConsentToggleLegitFont: {
      title: 'Legitimate Interest Font',
      type: 'Font'
    }
  },
  'vendors count style': {
    vendorCountFont: {
      title: 'Vendor Count Font',
      type: 'Font'
    }
  },
  'vendors count text': {
    vendorCountText: {
      title: 'Vendor Count Text',
      type: 'InputLanguage'
    }
  },
  'no vendors found style': {
    noVendorsFoundFont: {
      title: 'No Vendors Found Font',
      type: 'Font'
    }
  },
  'no vendors found text': {
    noVendorsFoundText: {
      title: 'No Vendors Found Text',
      type: 'InputLanguage'
    }
  },
  'vendors switch style': {
    vendorSwitchOnColor: {
      title: 'ON Color',
      type: 'ColorPicker'
    },
    vendorSwitchOffColor: {
      title: 'OFF Color',
      type: 'ColorPicker'
    }
  },
  'vendors search bar': {
    vendorSearchMagnifyingGlassColor: {
      title: 'Icon Color',
      type: 'ColorPicker'
    },
    vendorSearchPlaceholderText: {
      title: 'Placeholder Text',
      type: 'InputLanguage'
    },
    vendorSearchFontStyles: {
      title: 'Font Styles',
      type: 'Font'
    },
    vendorSearchBackgroundColor: {
      title: 'Background Color',
      type: 'ColorPicker'
    }
  },
  'categories orientations': {
    categoryWidth: {
      title: 'Width',
      type: 'Size'
    },
    categoryHeight: {
      title: 'Height',
      type: 'Size'
    },
    categoryPadding: {
      title: 'Padding',
      type: 'Padding'
    },
    categoryMargin: {
      title: 'Margin',
      type: 'Margin'
    }
  },
  'categories style': {
    categoryBackground: {
      title: 'Background Color',
      type: 'ColorPicker'
    },
    categoryBorder: {
      title: 'Border',
      type: 'Border'
    }
  },
  'categories cards orientation': {
    categoryCardsHeight: {
      title: 'Height',
      type: 'Size'
    },
    categoryCardsWidth: {
      title: 'Width',
      type: 'Size'
    },
    categoryCardsPadding: {
      title: 'Padding',
      type: 'Padding'
    },
    categoryCardsMargin: {
      title: 'Margin',
      type: 'Margin'
    }
  },
  'categories cards style': {
    categoryCardsBackground: {
      title: 'Background Color',
      type: 'ColorPicker'
    },
    categoryCardsBorder: {
      title: 'Border',
      type: 'Border'
    },
    categoryCardsFont: {
      title: 'Font',
      type: 'Font'
    },
    categoryArrowColor: {
      title: 'Arrow Color',
      type: 'ColorPicker'
    }
  },
  'categories chevron style': {
    categoryChevronColor: {
      title: 'Chevron Color',
      type: 'ColorPicker'
    }
  },
  'categories consent slider text': {
    categoryConsentToggleConsentText: {
      title: 'Consent Text',
      type: 'InputLanguage'
    },
    categoryConsentToggleLegitText: {
      title: 'Legitimate Interest Text',
      type: 'InputLanguage'
    }
  },
  'categories consent slider orientation': {
    categoryConsentToggleWidth: {
      title: 'Width',
      type: 'Size'
    },
    categoryConsentToggleHeight: {
      title: 'Height',
      type: 'Size'
    },
    categoryConsentTogglePadding: {
      title: 'Padding',
      type: 'Padding'
    },
    categoryConsentToggleMargin: {
      title: 'Margin',
      type: 'Margin'
    }
  },
  'categories consent slider style': {
    categoryConsentToggleBackground: {
      title: 'Off Switch Color',
      type: 'ColorPicker'
    },
    categoryConsentToggleOnBackground: {
      title: 'On Switch Color',
      type: 'ColorPicker'
    },
    categoryConsentToggleConsentFont: {
      title: 'Consent Font',
      type: 'Font'
    },
    categoryConsentToggleLegitFont: {
      title: 'Legitimate Interest Font',
      type: 'Font'
    }
  },
  'categories count style': {
    categoryCountFont: {
      title: 'Category Count Font',
      type: 'Font'
    }
  },
  'categories count text': {
    categoryPurposeCountText: {
      title: 'Purpose Count Text',
      type: 'InputLanguage'
    },
    categorySpecialPurposeCountText: {
      title: 'Special Purpose Count Text',
      type: 'InputLanguage'
    },
    categoryFeatureCountText: {
      title: 'Feature Count Text',
      type: 'InputLanguage'
    },
    categorySpecialFeatureCountText: {
      title: 'Special Feature Count Text',
      type: 'InputLanguage'
    }
  },
  'categories switch style': {
    categorySwitchOnColor: {
      title: 'ON Color',
      type: 'ColorPicker'
    },
    categorySwitchOffColor: {
      title: 'OFF Color',
      type: 'ColorPicker'
    }
  },
  'details preview settings': {
    detailsPreviewIndex: {
      title: 'Preview Item',
      type: 'CardDetailsPreview'
    }
  },
  'vendor details orientation': {
    vendorDetailsWidth: {
      title: 'Width',
      type: 'Size'
    },
    vendorDetailsPadding: {
      title: 'Padding',
      type: 'Padding'
    },
    vendorDetailsMargin: {
      title: 'Margin',
      type: 'Margin'
    }
  },
  'vendor details style': {
    vendorDetailsBackground: {
      title: 'Background Color',
      type: 'ColorPicker'
    },
    vendorDetailsBorder: {
      title: 'Border',
      type: 'Border'
    }
  },
  'vendor details title style': {
    vendorDetailsTitleFont: {
      title: 'Vendor Title Font',
      type: 'Font'
    }
  },
  'vendor details card orientation': {
    vendorDetailsCardHeight: {
      title: 'Height',
      type: 'Size'
    },
    vendorDetailsCardWidth: {
      title: 'Width',
      type: 'Size'
    },
    vendorDetailsCardPadding: {
      title: 'Padding',
      type: 'Padding'
    },
    vendorDetailsCardMargin: {
      title: 'Margin',
      type: 'Margin'
    }
  },
  'vendor details card style': {
    vendorDetailsCardBackground: {
      title: 'Background Color',
      type: 'ColorPicker'
    },
    vendorDetailsCardBorder: {
      title: 'Border',
      type: 'Border'
    },
    vendorDetailsCardFont: {
      title: 'List Item Font',
      type: 'Font'
    }
  },
  'vendor details category headers': {
    vendorDetailsPurposesText: {
      title: 'Purposes Text',
      type: 'InputLanguage'
    },
    vendorDetailsLegitText: {
      title: 'Legit. Interest Text',
      type: 'InputLanguage'
    },
    vendorDetailsFeatureText: {
      title: 'Features Text',
      type: 'InputLanguage'
    },
    vendorDetailsSpecialPurposeText: {
      title: 'Special Purpose Text',
      type: 'InputLanguage'
    },
    vendorDetailsCardHeaderFont: {
      title: 'Header Font',
      type: 'Font'
    }
  },
  'vendor details switch style': {
    vendorDetailsSwitchOnColor: {
      title: 'ON Color',
      type: 'ColorPicker'
    },
    vendorDetailsSwitchOffColor: {
      title: 'OFF Color',
      type: 'ColorPicker'
    }
  },
  'vendor details return button': {
    vendorDetailsReturnArrowColor: {
      title: 'Arrow Color',
      type: 'ColorPicker'
    },
    vendorDetailsReturnText: {
      title: 'Text',
      type: 'InputLanguage'
    },
    vendorDetailsReturnFont: {
      title: 'Font',
      type: 'Font'
    }
  },
  'category details orientation': {
    categoryDetailsWidth: {
      title: 'Width',
      type: 'Size'
    },
    categoryDetailsPadding: {
      title: 'Padding',
      type: 'Padding'
    },
    categoryDetailsMargin: {
      title: 'Margin',
      type: 'Margin'
    }
  },
  'category details style': {
    categoryDetailsBackground: {
      title: 'Background Color',
      type: 'ColorPicker'
    },
    categoryDetailsBorder: {
      title: 'Border',
      type: 'Border'
    }
  },
  'category details title font': {
    categoryDetailsTitleFont: {
      title: 'Category Title Font',
      type: 'Font'
    }
  },
  'category details description font': {
    categoryDetailsDescriptionFont: {
      title: 'Category Description Font',
      type: 'Font'
    }
  },
  'category details switch style': {
    categoryDetailsSwitchOnColor: {
      title: 'ON Color',
      type: 'ColorPicker'
    },
    categoryDetailsSwitchOffColor: {
      title: 'OFF Color',
      type: 'ColorPicker'
    }
  },
  'category details vendor count': {
    categoryDetailsVendorCountText: {
      title: 'Text',
      type: 'InputLanguage'
    },
    categoryDetailsVendorCountFont: {
      title: 'Font',
      type: 'Font'
    }
  },
  'category details return button': {
    categoryDetailsReturnArrowColor: {
      title: 'Arrow Color',
      type: 'ColorPicker'
    },
    categoryDetailsReturnText: {
      title: 'Text',
      type: 'InputLanguage'
    },
    categoryDetailsReturnFont: {
      title: 'Font',
      type: 'Font'
    }
  },
  'category details vendor description': {
    categoryDetailsVendorQr: {
      title: 'Show QR Code',
      type: 'Switch'
    },
    categoryDetailsVendorUrl: {
      title: 'Show Vendor URL',
      type: 'Switch'
    }
  },
  'category details vendor description styles': {
    categoryDetailsVendorContainerColor: {
      title: 'Container Color',
      type: 'ColorPicker'
    },
    categoryDetailsVendorFont: {
      title: 'Vendor Name Font',
      type: 'Font'
    },
    categoryDetailsVendorUrlFont: {
      title: 'Vendor URL Font',
      type: 'Font'
    }
  }
};